var _rect, _g, _path, _g2, _path2, _path3, _g3, _g4, _path4, _g5, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeSeries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 200,
    viewBox: "0 0 244 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_319_3)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 200,
    rx: 6.97143,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_319_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 20.5,
    width: 203.5,
    height: 159.5,
    rx: 11,
    fill: "#F7FAFC",
    fillOpacity: 0.36
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_319_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 38,
    width: 201,
    height: 194
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2778 53.6423C36.3918 53.6423 29.8859 121.9 22 121.9V232H222.5V38C214.614 38 208.108 110.523 200.222 110.523C192.336 110.523 185.83 82.0828 177.944 82.0828C170.059 82.0828 163.553 115.634 155.667 115.634C147.781 115.634 141.275 82.0828 133.389 82.0828C125.503 82.0828 117.041 95.0116 109.155 95.0116C97.3098 95.0116 96.7193 59.3304 88.8333 59.3304C80.9474 59.3304 74.4415 151.762 66.5556 151.762C58.6696 151.762 52.1637 53.6423 44.2778 53.6423Z",
    fill: "#F2AEAE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_319_3)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_319_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 38H31.7805V206.72H22V38Z",
    fill: "url(#paint0_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6049 38H49.3854V206.72H39.6049V38Z",
    fill: "url(#paint1_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2098 38H66.9903V206.72H57.2098V38Z",
    fill: "url(#paint2_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8146 38H84.5951V206.72H74.8146V38Z",
    fill: "url(#paint3_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4195 38H102.2V206.72H92.4195V38Z",
    fill: "url(#paint4_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.024 38H119.805V206.72H110.024V38Z",
    fill: "url(#paint5_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.629 38H137.41V206.72H127.629V38Z",
    fill: "url(#paint6_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.234 38H155.015V206.72H145.234V38Z",
    fill: "url(#paint7_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.839 38H172.62V206.72H162.839V38Z",
    fill: "url(#paint8_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.444 38H190.224V206.72H180.444V38Z",
    fill: "url(#paint9_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.049 38H207.829V206.72H198.049V38Z",
    fill: "url(#paint10_linear_319_3)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.654 38H225.434V206.72H215.654V38Z",
    fill: "url(#paint11_linear_319_3)",
    fillOpacity: 0.2
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 122.022C29.8887 122.022 36.397 53.5 44.2857 53.5C52.1745 53.5 58.6827 152 66.5714 152C74.4602 152 80.9684 59.2101 88.8571 59.2101C96.7459 59.2101 97.3366 95.0296 109.186 95.0296C117.075 95.0296 125.54 82.0507 133.429 82.0507C141.317 82.0507 147.826 115.732 155.714 115.732C163.603 115.732 170.111 82.0507 178 82.0507",
    stroke: "#9F7AEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178 82.0686C185.876 82.0686 192.374 110.5 200.25 110.5C208.126 110.5 214.624 38 222.5 38",
    stroke: "#9F7AEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_319_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.541,
    y: 81.9661,
    width: 2.29799,
    height: 117.609,
    fill: "url(#paint12_linear_319_3)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_319_3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.402,
    cy: 80.0425,
    rx: 5.45774,
    ry: 5.22096,
    fill: "#4C94FF"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_319_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.5 56.6076C188.5 56.3038 188.187 56 187.874 56H182.24C181.927 56 181.615 56.3038 181.615 56.6076V57.8228C181.615 58.1266 181.927 58.4304 182.24 58.4304H184.223L179.632 62.8861L175.146 58.5316C174.625 58.0253 173.894 58.0253 173.373 58.5316L168.156 63.5949C167.948 63.7975 167.948 64.2025 168.156 64.5063L168.991 65.4177C169.2 65.6203 169.617 65.6203 169.93 65.4177L174.207 61.2658L178.693 65.6203C179.215 66.1266 179.945 66.1266 180.467 65.6203L185.892 60.2532V62.1772C185.892 62.481 186.205 62.7848 186.518 62.7848H187.77C188.083 62.7848 188.396 62.481 188.396 62.1772L188.5 56.6076Z",
    fill: "url(#paint13_linear_319_3)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.995 169.864L220.995 177L217.505 177L217.505 169.864L216.201 169.864C215.57 169.864 215.276 169.1 215.696 168.675L218.556 165.787C218.935 165.404 219.523 165.404 219.902 165.787L222.804 168.675C223.224 169.1 222.93 169.864 222.299 169.864L220.995 169.864Z",
    fill: "url(#paint14_linear_319_3)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_319_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.5,
    y: 32.5,
    width: 66.5,
    height: 15,
    rx: 7.5,
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.47 144.082L209.47 150.648L205.358 150.648L205.358 144.082L203.816 144.082C203.074 144.082 202.731 143.225 203.245 142.711L206.615 139.343C207.072 138.886 207.757 138.886 208.214 139.343L211.584 142.711C212.098 143.225 211.755 144.082 211.013 144.082L209.47 144.082Z",
    fill: "url(#paint15_linear_319_3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.596 119.826L224.596 128L220.404 128L220.404 119.826L218.832 119.826C218.076 119.826 217.726 118.76 218.25 118.12L221.685 113.926C222.151 113.358 222.849 113.358 223.315 113.926L226.75 118.12C227.274 118.76 226.924 119.826 226.168 119.826L224.596 119.826Z",
    fill: "url(#paint16_linear_319_3)",
    fillOpacity: 0.85
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5916 42.5597V36.0227H98.2443V42.5597H96.5916ZM94.1495 40.1175V38.4648H100.686V40.1175H94.1495ZM106.282 42.2273V41.7287C106.282 41.3501 106.362 41.0024 106.522 40.6854C106.686 40.3653 106.921 40.1098 107.229 39.919C107.54 39.7251 107.918 39.6282 108.364 39.6282C108.817 39.6282 109.197 39.7236 109.505 39.9144C109.815 40.1052 110.049 40.3607 110.206 40.6808C110.366 40.9978 110.446 41.3471 110.446 41.7287V42.2273C110.446 42.6058 110.366 42.9551 110.206 43.2752C110.046 43.5922 109.811 43.8461 109.5 44.0369C109.189 44.2308 108.811 44.3278 108.364 44.3278C107.912 44.3278 107.532 44.2308 107.224 44.0369C106.916 43.8461 106.682 43.5922 106.522 43.2752C106.362 42.9551 106.282 42.6058 106.282 42.2273ZM107.626 41.7287V42.2273C107.626 42.4458 107.678 42.652 107.783 42.8459C107.89 43.0398 108.084 43.1367 108.364 43.1367C108.644 43.1367 108.835 43.0413 108.937 42.8505C109.041 42.6597 109.094 42.4519 109.094 42.2273V41.7287C109.094 41.504 109.045 41.2947 108.946 41.1009C108.848 40.907 108.654 40.81 108.364 40.81C108.087 40.81 107.895 40.907 107.787 41.1009C107.68 41.2947 107.626 41.504 107.626 41.7287ZM101.43 36.8168V36.3182C101.43 35.9366 101.512 35.5872 101.675 35.2702C101.838 34.9502 102.074 34.6947 102.381 34.5039C102.692 34.3131 103.068 34.2177 103.508 34.2177C103.963 34.2177 104.345 34.3131 104.653 34.5039C104.96 34.6947 105.194 34.9502 105.354 35.2702C105.514 35.5872 105.594 35.9366 105.594 36.3182V36.8168C105.594 37.1984 105.513 37.5477 105.35 37.8647C105.19 38.1817 104.954 38.4356 104.643 38.6264C104.336 38.8142 103.957 38.908 103.508 38.908C103.059 38.908 102.678 38.8126 102.368 38.6218C102.06 38.4279 101.826 38.174 101.666 37.8601C101.509 37.5431 101.43 37.1953 101.43 36.8168ZM102.783 36.3182V36.8168C102.783 37.0414 102.835 37.2492 102.94 37.44C103.048 37.6308 103.237 37.7262 103.508 37.7262C103.791 37.7262 103.983 37.6308 104.085 37.44C104.19 37.2492 104.242 37.0414 104.242 36.8168V36.3182C104.242 36.0935 104.193 35.8842 104.094 35.6903C103.996 35.4964 103.8 35.3995 103.508 35.3995C103.234 35.3995 103.045 35.498 102.94 35.695C102.835 35.8919 102.783 36.0997 102.783 36.3182ZM102.04 44L108.54 34.5455H109.749L103.249 44H102.04Z",
    fill: "url(#paint17_radial_319_3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7353 44.3317H66.6225C66.3113 44.3317 66 44.0208 66 43.71V33.1419C66 32.8311 66.3113 32.5203 66.6225 32.5203H69.7353C70.0465 32.5203 70.3578 32.8311 70.3578 33.1419V43.71C70.3578 44.0208 70.0465 44.3317 69.7353 44.3317Z",
    fill: "url(#paint18_linear_319_3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.829 44.3318H74.7163C74.405 44.3318 74.0938 44.021 74.0938 43.7102V37.0274C74.0938 36.7166 74.405 36.4058 74.7163 36.4058H77.829C78.1403 36.4058 78.4516 36.7166 78.4516 37.0274V43.7102C78.4516 44.021 78.1403 44.3318 77.829 44.3318Z",
    fill: "url(#paint19_linear_319_3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9218 44.3318H82.8091C82.4978 44.3318 82.1865 44.0209 82.1865 43.7101V31.1217C82.1865 30.8108 82.4978 30.5 82.8091 30.5H85.9218C86.2331 30.5 86.5443 30.8108 86.5443 31.1217V43.7101C86.5443 44.0209 86.3887 44.3318 85.9218 44.3318Z",
    fill: "url(#paint20_linear_319_3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6022 44.3312H67.8669C67.7113 44.3312 67.5557 44.1758 67.5557 44.0204V39.8243C67.5557 39.6688 67.7113 39.5134 67.8669 39.5134H71.6022C71.7578 39.5134 71.9135 39.6688 71.9135 39.8243V44.0204C71.9135 44.1758 71.7578 44.3312 71.6022 44.3312Z",
    fill: "#81B3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8516 44.3315H75.9607C75.805 44.3315 75.6494 44.1761 75.6494 44.0207V42.0003C75.6494 41.8449 75.805 41.6895 75.9607 41.6895H79.8516C80.0072 41.6895 80.1629 41.8449 80.1629 42.0003V44.0207C80.0072 44.1761 80.0072 44.3315 79.8516 44.3315Z",
    fill: "#81B3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9459 44.3318H84.2107C84.0551 44.3318 83.8994 44.1764 83.8994 44.021V41.0681C83.8994 40.9127 84.0551 40.7573 84.2107 40.7573H87.9459C88.1016 40.7573 88.2572 40.9127 88.2572 41.0681V44.021C88.2572 44.1764 88.2572 44.3318 87.9459 44.3318Z",
    fill: "#81B3FF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 242,
    height: 198,
    rx: 5.97143,
    stroke: "#9F7AEA",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_319_3",
    x: -22,
    y: -20.5,
    width: 285.5,
    height: 241.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.5,
    result: "effect1_foregroundBlur_319_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_319_3",
    x: 19.5,
    y: 35.5,
    width: 208.434,
    height: 173.719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25,
    result: "effect1_foregroundBlur_319_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_319_3",
    x: 168.444,
    y: 70.3215,
    width: 17.9155,
    height: 131.754,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_319_3",
    x: 168.444,
    y: 72.8215,
    width: 17.9155,
    height: 17.4419,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.580392 0 0 0 0 1 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_319_3",
    x: 166,
    y: 55.5,
    width: 24.5,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.122344 0 0 0 0 0.208887 0 0 0 0 0.3375 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_319_3",
    x: 49.5,
    y: 28.5,
    width: 76.5,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.703608 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_319_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_319_3",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_319_3",
    x1: 123.717,
    y1: 10,
    x2: 123.714,
    y2: 206.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_319_3",
    x1: 177.69,
    y1: 81.9661,
    x2: 177.69,
    y2: 199.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C94FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_319_3",
    x1: 166.17,
    y1: 67.4286,
    x2: 183.764,
    y2: 49.9407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#81B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_319_3",
    x1: 219.181,
    y1: 160.665,
    x2: 219.256,
    y2: 176.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#9F7AEA",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_319_3",
    x1: 207.5,
    y1: 136,
    x2: 207.423,
    y2: 150.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#9F7AEA",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_319_3",
    x1: 222.587,
    y1: 111.322,
    x2: 222.47,
    y2: 127.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_319_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.5 39) rotate(90) scale(8 9.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.586458,
    stopColor: "#81B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C94FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_319_3",
    x1: 68.1789,
    y1: 32.5203,
    x2: 68,
    y2: 49.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_319_3",
    x1: 76.2727,
    y1: 36.4058,
    x2: 76.5,
    y2: 49.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_319_3",
    x1: 84.3654,
    y1: 30.5,
    x2: 84.5,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F7AEA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 244,
    height: 200,
    rx: 6.97143,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSeries);
export default __webpack_public_path__ + "static/media/time-series.942faec96c29b8f8de5dafb779bfb5d4.svg";
export { ForwardRef as ReactComponent };